<template>
  <div class="contentwrapper">
    <div class="content-dark multi-page" v-if="currentOrder !== null">
      <h1>Thanks for your order</h1>
      <span class="subtitle">#{{ currentOrder.order_id }}</span>
      <hr />
      <p>Please choose which magazine in your order you would like to track</p>
      <div class="product-selector">
        <div class="product" v-for="(p, index) in currentOrder.products" :key="index">
          <div class="image-wrap" v-if="p.cover_image">
            <img :src="p.cover_image" />
          </div>
          <div class="detail">
            <h4>{{ p.magazine_name }}</h4>
            <p v-if="hasDeliveryAddress(p)">
              {{ p.fulfilment.delivery.title }}
              {{ p.fulfilment.delivery.first_name }}
              {{ p.fulfilment.delivery.last_name }}<br />
              {{ p.fulfilment.delivery.address_line_1 }}<br />

              {{ p.fulfilment.delivery.post_code }}<br />
            </p>
            <p v-else></p>
          </div>
          <button class="button-default" v-on:click="checkOrderType(p, index)">Track</button>
        </div>
      </div>
    </div>

    <div class="overlay-wrapper" v-if="dialogShowingType">
      <div class="dialog">
        <button v-on:click="dialogShowingType = null">X</button>
        <p v-if="dialogShowingType === 'single'">
          All single issue orders placed before 2:30pm will be dispatched on the same working day.
          Orders placed after 2:30pm will be dispatched on the next working day. All orders are sent
          Royal Mail 1st Class - please refer to the Royal Mail website for delivery timescales.
          <br /><br />
          If you have any questions about your order please contact
          <a href="mailto:magazinecouk-singleissues@subscriptionhelpline.co.uk"
            >magazinecouk-singleissues@subscriptionhelpline.co.uk</a
          >.
        </p>
        <p v-else-if="dialogShowingType === 'gift'">
          All gift card orders will be dispatched the next working day after your order is placed.
          All orders are sent Royal Mail 1st Class - please refer to the Royal Mail website for
          delivery timescales.
          <br /><br />
          If you have any questions about your order please contact
          <a href="mailto:enquiries@magazine.co.uk">enquiries@magazine.co.uk</a>.
        </p>
        <p v-else-if="dialogShowingType === 'egift'">
          Your e-gift card will be emailed to your recipient on the date chosen at the time of
          purchase.
          <br /><br />
          If you have any questions about your order please contact
          <a href="mailto:enquiries@magazine.co.uk">enquiries@magazine.co.uk</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderMulti",
  components: {},
  props: {},
  data() {
    return {
      dialogShowingType: null,
      transaction_ref: this.$route.params.transref
    };
  },

  mounted() {
    this.$store.dispatch("getOrder", this.transaction_ref);
  },
  methods: {
    checkOrderType(p, index) {
      //if single issue display notice
      if (this.isSingleIssue(p)) {
        this.dialogShowingType = "single";
      } else if (this.isGiftVoucher(p)) {
        this.dialogShowingType = "gift";
      } else if (this.isEGiftVoucher(p)) {
        this.dialogShowingType = "egift";
      } else {
        this.dialogShowingType = null;
        this.goToOrderProcess(index);
      }
    },
    goToOrderProcess(index) {
      this.$router.push("/" + this.transaction_ref + "/order-progress/" + index);
    },
    hasDeliveryAddress(p) {
      return (
        p.fulfilment.delivery.address_line_1.length > 0 ||
        p.fulfilment.delivery.first_name.length > 0 ||
        p.fulfilment.delivery.last_name.length > 0
      );
    },
    isSingleIssue(f) {
      return f.campaign_ref.startsWith("4");
    },
    isGiftVoucher(f) {
      return f.campaign_ref.toLowerCase() === "gift";
    },
    isEGiftVoucher(f) {
      return f.campaign_ref.toLowerCase() === "egft";
    }
  },
  computed: {
    currentOrder() {
      var response = this.$store.state.orderResponse;
      return response != null ? this.$store.state.orderResponse.order : null;
    }
  }
};
</script>
<style lang="scss">
.multi-page {
  margin: 0 20px;
  text-align: center;
}

.product-selector {
  text-align: left;
  display: flex;
  flex-direction: column;

  .product {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    border-bottom: 1px solid #c4c4c4;
    margin-bottom: 12px;
    padding-bottom: 12px;

    &:last-child {
      border-bottom-width: 0;
    }

    h4 {
      margin: 0;
      font-weight: 800;
    }

    p {
      margin: 0;
      font-weight: 600;
    }

    .image-wrap {
      display: flex;
    }

    img {
      width: 75px;
      height: auto;
      align-self: flex-start;
    }

    .detail {
      margin: 0 20px;
      flex-grow: 1;
    }

    .button-default {
      align-self: center;
      min-width: 70px;
    }
  }
}
</style>
